YP.SearchManager = function() {
    var searchContainer = $("#js-search-container");
    var form       = $("#js-search-container form");
    var isLoading = false;

    var categoriesContainer = $("#js-search-container #js-categories-container");
    var categoriesSelect = $("#js-search-container #js-categories-select");
    var categoriesResult = $("#js-search-container #js-categories-result");

    var dateContainer = $("#js-search-container #js-date-container");
    var dateSelect = $("#js-search-container #js-date-select");

    var cityContainer = $("#js-search-container #js-city-container");
    var citySelect = $("#js-search-container #js-city-select");

    return {
        init: function() {
            if (form.length === 0) {
                return;
            }
            $(categoriesSelect).on("change", { klass: this}, this.doSearchCategories);
            $(dateSelect).on("change", { klass: this}, this.doSearchDate);
            this.showMobileFilter();
            this.addActiveValue();
            this.showMultiselect();

            if ($("form#form_search_events").length === 0) {
                return;
            }
            $(window).scroll(function() {

                if( ( $(window).scrollTop() + $(window).height() + 150 ) >= $("#search-results").height() && !isLoading){
                    var _formSearch       = $("#form_search_events")

                    isLoading = true
                    $("#loader-search").fadeIn();

                    $.ajax({
                        method : "GET",
                        url : _formSearch.attr("action"),
                        data : {
                            "city" : ($(citySelect, _formSearch).val() == $(citySelect, _formSearch).attr("placeholder") ) ? "" : $(citySelect, _formSearch).val(),
                            "query" : ($("#search", _formSearch).val() == $("#search", _formSearch).attr("placeholder") ) ? "" : $("#search", _formSearch).val(),
                            "interval" : $(dateSelect, _formSearch).val(),
                            "offset" : _formSearch.data("offset"),
                            "limit" : _formSearch.data("limit"),
                            "price" : $("#price", _formSearch).val(),
                            "categories" : $(categoriesResult, _formSearch).val()
                        },
                        dataType: "json",
                        success: function(data){
                            $("#loader-search").fadeOut();
                            if(data.count == 30){
                                isLoading = false
                            }

                            if(data.view){
                                $("#search-results-container").append(data.view)
                                $("#form_search_events").data("offset", Number( _formSearch.data("offset") ) + data.count )
                            }
                        }
                    })
                }
            });

        },

        doSearchCategories: function(e){
            e.preventDefault();

            $(categoriesResult).val($(this).val());

            var latestValue = $("option:selected:first",this).val();
            if(latestValue == "all") {
                $(categoriesResult).val("");
                form.submit();
            }
            
            if(!$(this).hasClass('active')) {
                form.submit();
            }

        },

        doSearchDate: function(e){
            e.preventDefault();

            dateSelect.val($(this).val());

            if(!$(this).hasClass('active')) {
                form.submit();
            }          

        },

        addActiveValue: function(){
            // Add active when a value is selected
            categoriesOptionValue = $(categoriesSelect).val();

            if(categoriesOptionValue < 1){
                $(categoriesContainer).removeClass("input_active");
            }
            else{
                $(categoriesContainer).addClass("input_active");
            }

            dateOptionValue = $(dateSelect).val();

            if(dateOptionValue == "all"){
                $(dateContainer).removeClass("input_active");
            }
            else{
                $(dateContainer).addClass("input_active");
            }

            if($(citySelect).val()!=""){
                $(cityContainer).addClass("input_active");
            }
            else{
                $(cityContainer).removeClass("input_active");
            }

            // Remove reset button when no value
            if($('.input_active').length > 0) {
                $('#reset-btn').css('display', "block");
            }
            else {
                $('#reset-btn').css('display', "none");
            }

            // Show submit btn when focus in
            $(cityContainer).focusin(function() {
                $("#city-btn").css('display', "block");
            });

            $("#search").focusin(function() {
                $("#search-btn").css('display', "block");
            });

        },

        showMultiselect: function(){

            // Replace multiselect values tags for a count
            var uldiv = $(categoriesSelect).siblings('div').find('ul')
            if(count==0){
                uldiv.html("Toutes les catégories")
            }
            else if (count==1){
                uldiv.html("<li>"+count+" catégorie sélectionnée</li>")
            }
            else{
                uldiv.html("<li>"+count+" catégories sélectionnées</li>")
            }
        },

        showMobileFilter: function(){
            // Mobile filter toggle
            $("#js-filter-btn").on("click", function() {
                $(searchContainer).addClass("active");
                $(dateSelect).addClass("active");
                $(categoriesSelect).addClass("active");
                
            });
            $("#js-filter-close-btn").on("click", function() {
                $(searchContainer).removeClass("active");
                $(dateSelect).removeClass("active");
                $(categoriesSelect).removeClass("active");
            });
        }
    }
}


window.addEventListener("load", function(){
    YP.SearchManager().init();
});

